export default __webpack_public_path__ + "static/media/upgrade-bg.3485bc4d.svg";